import styled from "styled-components";

export const CommentCardWrapper = styled.div`
  border-radius: 21px;
  padding: 4.5rem 2.5rem 2.5rem;
  background-color: #FFFFFF;
  position: relative;
  box-shadow: 0 15px 50px 0 rgba(79, 104, 145, 0.15);
  width: 90%;
  -webkit-box-shadow: 0 15px 50px 0 rgba(79, 104, 145, 0.15);
  -moz-box-shadow: 0 15px 50px 0 rgba(79, 104, 145, 0.15);
  z-index: 9;
  height: 280px;

  &:not(.next-comment, .active) {
    display: none;
  }
  
  &:not(.active) {
    background-color: #D3D8DF;
    z-index: 8;
    opacity: .4;
    transform: translate3d(-70px, -170px, 0);

    i::before {
      color: var(--gray-color);
    }
  }

  @media (max-width: 992px) {
    width: 100%;
    padding: 4.5rem 1.5rem 2.5rem;
    height: 300px;

    &:not(.active) {
      transform: translate3d(15px, -266px, 0);
    }
  }
`;

export const AvatarContainer = styled.div`
  width: 77px;
  height: 77px;
  overflow: hidden;
  border-radius: 50%;
  position: absolute;
  top: -38px;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  @media (max-width: 992px) {
    right: calc(50% - 38px);
  }
`;

export const UserComment = styled.p`
  line-height: 1.8rem;
`;

export const UserName = styled.p`
  color: var(--dark-gray-color);
  font-size: 1.2rem;
  margin-bottom: 0;
`;

export const UserType = styled.p`
  color: var(--gray-color);
  font-size: .9rem;
  margin-bottom: 0;
  margin-top: .5rem;
`;
